<template lang="pug">
.compensacao-table
    grid-table-component(:headers='headersCompensacao', :data='compensacoes', :is-paginated='false')
        template(v-slot:alternativa='{ item }')
            span {{ item.alternativa | enum(AlternativaEnum) }}

        template(v-slot:area='{ item }')
            span {{ item.area | decimal }}

        template(v-slot:bioma='{ item }')
            span {{ item.bioma | enum(BiomaEnum) }}

        template(v-slot:codigoImovelExcedente='{ item }')
            span(v-tooltip='{ label: item?.imovelExcedenteCondicao, position: "bottom", minWidth: "360px" }') {{ item.codigoImovelExcedente | ellipsis(6, 4) }}

        template(v-slot:copiarCodigoImovelExcedente='{ item }')
            span(v-tooltip='{ label: "Copiar", position: "bottom", minWidth: "30px" }')
                button-component.copy-button(
                    label='',
                    icon='mdi-content-copy',
                    color='green',
                    @click.native='copyClipboard(item)'
                )

        template(v-slot:inicio='{ item }')
            span {{ item.inicio | data }}

        template(v-slot:fim='{ item }')
            span {{ item.fim | data }}

        template(v-slot:acao='{ item }')
            dropdown-component(
                v-if="item?.documentos"
                :list='acao'
                @input="onAction($event, item)"
                :is-select='false'
                position='left'
            )

        template(v-slot:validacao='{ item }')
            validacao-component(
                :tipo='item.tipo',
                :item='item',
                :tipos-documentos='tiposDocumentos',
            )

    modal-component(
        v-if='exibirModalDocumentos',
        title='Documentos',
        @close='exibirModalDocumentos = false'
    )
        AnaliseModalDocumentos(:etapa='itemSelecionado')
</template>

<script>

import ValidacaoComponent from '@/views/analise/components/ValidacaoComponent.vue';
import { BiomaEnum } from '@/enums/imovel.enum.js';
import { AlternativaEnum } from '@/enums/mra.enum.js';
import AnaliseModalDocumentos from '@/views/analise/components/AnaliseModalDocumentos.vue';

export default {

    name: 'MraCompensacaoTable',

    components: {
        ValidacaoComponent,
        AnaliseModalDocumentos
    },

    props: {
        compensacoes: {
            type: Array,
        },

        tiposDocumentos: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            headersCompensacao: [
                { text: 'Alternativa de Compensação', field: 'alternativa' },
                { text: 'Área a compensar (ha)', field: 'area', width: '70px' },
                { text: 'CAR com excedente', field: 'codigoImovelExcedente' },
                { text: '', field: 'copiarCodigoImovelExcedente' },
                { text: 'Bioma', field: 'bioma' },
                { text: 'Início', field: 'inicio' },
                { text: 'Fim', field: 'fim' },
                { text: 'Código UC', field: 'codigoCNUC' },
                { text: 'Ação', field: 'acao' },
                { text: 'Avaliação', field: 'validacao' },
            ],

            AlternativaEnum,
            BiomaEnum,
            acao: [{ id: 'DOC', label: 'Documentos', icon: 'mdi-text-box-search-outline' }],
            exibirModalDocumentos: false,
            itemSelecionado: null
        };
    },

    methods: {
        onAction(event, item) {
            if (event.id === 'DOC') {
                this.itemSelecionado = item;
                this.exibirModalDocumentos = true;
            }
        },
        copyClipboard(item) {
            navigator.clipboard.writeText(item.codigoImovelExcedente);
            this.$toast({
                showClose: true,
                message: 'Código Copiado',
                type: 'success'
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.copy-button {
    background-color: transparent !important;
    box-shadow: none !important;
}
</style>
